module.exports = __webpack_public_path__ + "files/ec89cfbed2c3cba4fb23598cf671d487.png";